import http from 'hub-http/clients/apiClient';
import { catchBoardError } from '../../../error/utils';
export const pipelineValidationBatch = objectValidations => {
  return catchBoardError('pipeline validation', http.post('/pipelines-validation/v2/validate/objects/batch', {
    data: {
      objectValidations
    }
  }));
};